module.exports = __webpack_public_path__ + "img/fond_tokyo_ghoul.efdedb3a.jpg";